/* eslint-disable max-len */
export const Follow = { url: "/api/follow/%7Baction%7D", type: undefined as { action: string | number; } };
